<div class="no-scheme">
  <div class="error" *ngIf="isError">
    <div class="mb-3 error-img">
      <img class="image" src="assets/images/somethingwrong.svg" alt="">
    </div>
    <div class="text-center">
      {{'error.dept-error' | translate}}
    </div>
  </div>
  <div *ngIf="!isError">
    <div class="center">
      <img class="empty" src="assets/images/empty.svg" alt="" />
    </div>
    <div class="center">
      <img src="assets/images/empty-base.svg" alt="" />
    </div>
    <div class="center blackcolor">
      <span class="noscheme">
        {{ errorMessage | translate }}.
      </span>
    </div>
    <br />
    <!-- <div class="center">
      {{ "pages.umang.L.noDoc" | translate }}. <br />
    </div> -->
    <!-- <div class="center">
      <button (click)="cancelSearch(true)" class="reset" type="button">
        <span class="text-content"> {{ "pages.scheme.resetFilters" | translate}} </span>
      </button>
    </div> -->
  </div>
  
</div>